<template>
  <div class="h-100 d-flex flex-column flex-md-row col-md-12 col-lg-8 item">
    <div
      class="flex-column col-md-6 justify-content-center flex-grow-1 overflow-auto img-div"
      :style="{
        backgroundImage: 'url(' + data.img + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }"
    ></div>
    <div class="flex-column col-md-6 justify-content-center pt-0 p-3 px-md-5">
      <div class="row h-100 align-content-between align-content-md-start">
        <div>
          <div
            class="price text-start d-none d-md-block back"
            @click="this.$router.back()"
          >
            Back
          </div>
          <div class="pt-4 pb-5">
            <div class="title text-start">{{ data.title }}</div>
            <div class="price text-start pt-2" v-if="data.price">
              € {{ data.price }}
            </div>
          </div>
        </div>
        <div>
          <div id="mody" class="text-start"></div>
          <div id="mody-vto"></div>
          <div
            class="size-table text-start mt-2 mb-2 d-flex align-items-center"
          >
            <div class="d-flex justify-content-center align-items-center">
              <img
                src="@/assets/img/clotheshanger.svg"
                class="icon pe-2"
                alt=""
              />
              <span class="size-text">Size guide</span>
            </div>
          </div>
          <div class="py-2 text-start d-flex flex-wrap">
            <div class="pe-1 mb-1" v-for="s in data.sizes" :key="s">
              <span class="size-list">{{ s.size }}</span>
            </div>
          </div>
          <button
            class="size"
            type="button"
            :disabled="cartBusy"
            @click="addToCart"
          >
            {{ cartBusy ? "ADDING..." : cartAdded ? "ADDED TO CART" : "ADD TO CART" }}
          </button>
          <div v-if="cartMessage" class="cart-status" role="status">
            {{ cartMessage }}
          </div>
          <div class="d-none d-md-block">
            <div class="w-100 justify-content-center d-flex">
              <div class="note note-selected">Shipping</div>
              <div class="note">Description</div>
              <div class="note">Materieals</div>
            </div>
            <div class="py-3 px-2">
              <p style="font-size: 0.8rem" class="text-start">
                Standard delivery is free on all orders containing at least one
                product from the New Collection. Express Shipping is subject to
                a fee. Check out the FAQs to find out more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEntityItem, injectModyScript } from "@/utilities";

export default {
  data() {
    return {
      data: {},
      cartBusy: false,
      cartAdded: false,
      cartMessage: "",
    };
  },
  async mounted() {
    await this.loadProduct();
    this.injectModyWidget();
  },
  watch: {
    // Vue Router reuses this component when only the params change
    // (product -> product): created/mounted do NOT re-run, so reload the
    // data and re-bind the widget explicitly.
    async $route(to) {
      if (to.name === "product") {
        await this.loadProduct();
        this.injectModyWidget();
      }
    },
  },
  methods: {
    async loadProduct() {
      const brand = this.$route.params.brand;
      const product = this.$route.params.product;
      this.cartAdded = false;
      this.cartMessage = "";
      try {
        this.data = (await getEntityItem(brand, product)) || {};
      } catch (e) {
        // One retry: the first Firestore read of a fresh session can fail
        // transiently (cold connection); without it the page stays blank
        // until a manual refresh.
        console.error("product load failed, retrying", e);
        try {
          this.data = (await getEntityItem(brand, product)) || {};
        } catch (e2) {
          console.error("product load failed", e2);
          this.data = {};
        }
      }
    },
    addToCart() {
      if (this.cartBusy) return;

      const itemId = this.$route.params.product;
      if (!itemId) return;

      this.cartBusy = true;
      this.cartMessage = "";

      try {
        const storageKey = "mody_ecom_cart";
        let cart = [];
        try {
          const stored = JSON.parse(localStorage.getItem(storageKey) || "[]");
          cart = Array.isArray(stored) ? stored : [];
        } catch (_) {
          cart = [];
        }

        const existing = cart.find((line) => line.id === itemId);
        const cartQuantity = Number(existing?.cart_quantity || existing?.quantity || 0) + 1;
        const line = {
          id: itemId,
          variant_id: itemId,
          handle: itemId,
          title: this.data.title || itemId,
          quantity: 1,
          cart_quantity: cartQuantity,
        };

        if (existing) {
          existing.cart_quantity = cartQuantity;
        } else {
          cart.push(line);
        }
        localStorage.setItem(storageKey, JSON.stringify(cart));

        document.dispatchEvent(
          new CustomEvent("mody:ecom:cart:add", {
            bubbles: true,
            detail: {
              items: [line],
              status: 200,
              cart: { items: cart },
            },
          }),
        );

        this.cartAdded = true;
        this.cartMessage = `Added to cart (${cartQuantity})`;
      } catch (error) {
        this.cartMessage = "Unable to add this product to the cart";
        console.error("Ecom cart: add failed", error);
      } finally {
        this.cartBusy = false;
      }
    },
    injectModyWidget() {
      // The widget reads data-entity/data-item from its <script> tag once at
      // init. On SPA navigation the tag injected for the PREVIOUS product is
      // still in <head>, so the widget never binds to the new product until a
      // full page refresh — remove it and inject a fresh one, like a real
      // page load would.
      injectModyScript({
        assistant: true,
        entity: this.$route.params.brand,
        item: this.$route.params.product,
        itemName: this.data.name || this.data.title || this.data.productName || this.data.productTitle,
        gender: this.data.gender || this.data.Gender || this.data.target || this.data.audience,
        tag: "mody",
        vto: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#mody {
  font-size: 0.8rem;
}
.back {
  cursor: pointer;
}
.item {
  margin: auto;
}
.title {
  font-weight: bold;
  font-size: 1.2rem;
}
.price {
  font-weight: normal;
  font-size: 1rem;
}
.my-container {
  overflow: hidden;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: space-between;
}
.img-container {
  height: 500px;
  background-size: cover;
  background-position: center;
}
img {
  height: 100%;
  max-width: 100%;
}
.img-div {
  //border-bottom-right-radius: 24px;
  //border-bottom-left-radius: 24px;
}
.size-text {
  font-size: 1rem;
}
.size {
  margin-top: 8px;
  background-color: rgb(52, 52, 51);
  color: white;
  border: 1px solid black;
  padding: 16px 30px;
  width: 100%;
  letter-spacing: 0.05rem;
  //border-radius: 16px;
  font-size: 1rem;
}
.size:disabled {
  cursor: wait;
  opacity: 0.65;
}
.cart-status {
  color: #2f6b45;
  font-size: 0.85rem;
  padding-top: 8px;
  text-align: left;
}
.icon {
  height: 16px;
  float: left;
}
.size-list {
  padding: 16px;
  font-size: 1rem;
  background-color: #fff;
  color: #000;
  border: 1px solid #eee;
  display: flex;
  //border-radius: 8px;
  align-items: center;
  justify-content: center;
}

.size-table {
  font-size: 0.8rem;
}
.note {
  border: none;
  border-bottom: 1px solid #000;
  color: #000;
  background: none;
  padding: 10px 20px;
  margin-top: 5px;
  font-size: 1rem;
}
.note-selected {
  border-bottom: 3px solid #000;
  font-weight: 700;
}
@media (min-width: 768px) {
  .title {
    font-weight: bold;
    font-size: 1.2rem;
  }
  .price {
    font-size: 1rem;
  }
  .item {
    padding: 30px;
  }
}
@media (max-width: 767px) {
}
</style>
